import { container_classname } from "@components/new-ui/constants";
import Image from "next/image";

interface FeatureCard {
    imageUrl: string;
    title: string;

    description: string;
}

export interface FeatureSection {
    maintitle: string;
    subTitle?: string;
    featureSectionCard: FeatureCard[];
}
export interface FeatureHighlightSectionProps {
    featureSection?: FeatureSection;
    bgColor?: string;
    customStyle?: boolean;
}

const FeatureHighlightSection: React.FC<FeatureHighlightSectionProps> = ({ featureSection, customStyle }) => {
    return (
        <section className={`${customStyle ? "mb-0 py-20" : "mb-20 py-20 mt-20"}`} style={{ backgroundColor: "#E6EEFF" }}>
            <h5 className={`${container_classname} md:text-6xl text-4xl mb-12 `} style={{ fontFamily: "Degular Display" }}>
                {featureSection?.maintitle}
            </h5>
            <p className={`${container_classname} md:text-xl text-lg mb-12 font-normal `}>{featureSection?.subTitle}</p>
            <div className={`${container_classname} flex md:flex-row flex-col gap-5`}>
                {featureSection?.featureSectionCard.map((featureData, index) => (
                    <div key={index} className="flex flex-col gap-4 bg-white p-6 shadow-md">
                        <Image src={featureData.imageUrl} alt={featureData.title} width={48} height={48} className="h-12" />
                        <p className="font-semibold text-2xl">{featureData.title}</p>
                        <p className="self-end">{featureData.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default FeatureHighlightSection;
